import React from "react";
import { useParams } from "react-router-dom";
import "./style.css";

import GridTableMuatan from "../../../components/GridTableMuatan";
import { Collapse } from "antd";

const { Panel } = Collapse;

const Muatan = () => {
  let { nokapal, nokont } = useParams();
  return (
    <div className="content-height">
      <h3>
        NO. KAPAL {nokapal}, NO. KONT {nokont}
      </h3>
      <Collapse defaultActiveKey={["1"]}>
        <Panel header="DATA MUATAN" key="1">
          <GridTableMuatan nokapal={nokapal} nokont={nokont} />
        </Panel>
      </Collapse>
    </div>
  );
};

export default Muatan;
